import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc,
  DocumentData 
} from 'firebase/firestore';
import { db } from '../firebase';

// Check if Firebase is initialized
const checkFirebaseInit = () => {
  if (!db) {
    throw new Error('Firebase Firestore is not initialized');
  }
};

// Firestore Services
export const addDocument = async (collectionName: string, data: any): Promise<string | null> => {
  try {
    checkFirebaseInit();
    const docRef = await addDoc(collection(db!, collectionName), data);
    return docRef.id;
  } catch (error) {
    console.error('Error adding document:', error);
    throw error;
  }
};

export const getDocuments = async (collectionName: string): Promise<DocumentData[]> => {
  try {
    checkFirebaseInit();
    const querySnapshot = await getDocs(collection(db!, collectionName));
    const documents: DocumentData[] = [];
    querySnapshot.forEach((doc) => {
      documents.push({ id: doc.id, ...doc.data() });
    });
    return documents;
  } catch (error) {
    console.error('Error getting documents:', error);
    throw error;
  }
};

export const updateDocument = async (collectionName: string, docId: string, data: any): Promise<void> => {
  try {
    checkFirebaseInit();
    const docRef = doc(db!, collectionName, docId);
    await updateDoc(docRef, data);
  } catch (error) {
    console.error('Error updating document:', error);
    throw error;
  }
};

export const deleteDocument = async (collectionName: string, docId: string): Promise<void> => {
  try {
    checkFirebaseInit();
    await deleteDoc(doc(db!, collectionName, docId));
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
}; 